import { Flex } from "@radix-ui/themes";
import { useTrackerApi } from "@/v2/entities/tracker/Tracker.api";
import { useQuery } from "react-query";
import TrackerItemView from "./TrackerItemView";
import { EyeClosedIcon } from "@radix-ui/react-icons";
import styles from "./TicketQAScore.module.scss";

interface TrackerTicketViewProps {
  ticketId: string;
}

function TicketTrackersViewEmptyState() {
  return (
    <div className={styles.EmptyState}>
      <EyeClosedIcon />
      <div className={styles.Header}>Not captured by tracker</div>
    </div>
  );
}

function TicketTrackersView({ ticketId }: TrackerTicketViewProps) {
  const trackerApi = useTrackerApi();

  const {
    data: trackerItems,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["trackerItemsByTicketId", ticketId],
    queryFn: () => trackerApi.getTrackerItemBySource("tickets", ticketId),
  });

  if (isLoading) {
    return <></>;
  }

  if (!trackerItems?.length) {
    return (
      <div className={styles.Questions}>
        <div className={styles.QuestionList}>
          <TicketTrackersViewEmptyState />
        </div>
      </div>
    );
  }

  return (
    <Flex direction={"column"}>
      {trackerItems?.map((trackerItem) => {
        if (!trackerItem.tracker) {
          return null;
        }

        return (
          <TrackerItemView
            key={trackerItem.id}
            trackerItem={trackerItem}
            tracker={trackerItem.tracker}
            refetch={refetch}
          />
        );
      })}
    </Flex>
  );
}

export default TicketTrackersView;
